import { useEffect, useState } from 'react';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { recipeOperationsSearch, recipesSearch } from '@reducers/search';
import {
  GlobalSearchItem,
  RecipeOperationSearchItem,
  RecipeSearchItem,
} from '../../../../interfaces/search';

import { useManageOperationsBlock } from './useManageOperationsBlock';

export interface UseManageRecipeBlockParams {
  item: GlobalSearchItem | null;
  existingRecipe?: RecipeSearchItem;
  existingPart?: GlobalSearchItem | null;
}

export const useManageRecipeBlock = ({ item, existingRecipe, existingPart }: UseManageRecipeBlockParams) => {
  const dispatch = useAppDispatch();

  const [recipe, setRecipe] = useState<RecipeSearchItem | undefined>(existingRecipe);

  const base = useManageOperationsBlock<RecipeOperationSearchItem>({
    existingPart,
    partId: recipe?.partId,
  });
  const { setOperations, setIsError, setIsLoading } = base;

  useEffect(() => {
    if (existingRecipe) {
      return;
    }

    (async () => {
      setIsLoading(true);
      const resRecipe = await dispatch(
        recipesSearch(
          { search: '', top: 100, skip: 0 },
          { oDataFilter: `RecipeId eq ${item?.itemId}` }
        )
      );

      if (resRecipe?.searchResult) {
        setRecipe(resRecipe.searchResult[0]);
      } else {
        setIsError(true);
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!recipe) {
      return;
    }

    (async () => {
      setIsLoading(true);

      try {
        const res = await dispatch(
          recipeOperationsSearch({
            data: { search: '', top: 100, skip: 0 },
            filter: {
              oDataFilter: `RecipeId eq ${recipe?.recipeId}`,
              orderBy: ['SortOrder asc'],
            },
            select: null,
            resetHistory: true,
            ignoreHistory: true,
          })
        );

        if (res?.searchResult) {
          setOperations(res.searchResult);
        } else {
          setIsError(true);
        }
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [recipe]);

  return {
    ...base,
    recipe,
    setRecipe,
  };
};
